import axios from 'axios'
import { SearchUrlParamBuilder } from '@/core/utils'

const URL_PATH = 'api/processos'

class ProcessoApiClient {
	async buscarProcessoPorId(idProcesso) {
		return await axios.get(`${URL_PATH}/${idProcesso}`)
	}

	async buscarListagem(filtro, paginacao) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}`,
			filters: filtro,
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}

	async buscarOrgaosUsuarioFiltro(idOrgaoPromotor) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/orgaos`,
			filters: { idOrgaoPromotor },
		}).build()

		return await axios.get(url)
	}

	async buscarOrgaosQuantificaramNoProcesso({ nomeOuSigla, paginacao, idProcesso }) {
		const url = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/${idProcesso}/orgaos`,
			filters: { nomeOuSigla },
			pagingAndSorting: paginacao,
		}).build()
		return await axios.get(url)
	}
}
export default new ProcessoApiClient()
